"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualizationType = void 0;
var VisualizationType;
(function (VisualizationType) {
    VisualizationType["PROMO_CAROUSEL"] = "PROMO_CAROUSEL";
    VisualizationType["LINE_CHART"] = "LINE_CHART";
    VisualizationType["BAR_CHART"] = "BAR_CHART";
    VisualizationType["COMPOSED_CHART"] = "COMPOSED_CHART";
    VisualizationType["TABLE"] = "TABLE";
    VisualizationType["TEXT"] = "TEXT";
    VisualizationType["VALUE"] = "VALUE";
    VisualizationType["HTML"] = "HTML";
    VisualizationType["FEATURE_LIST"] = "FEATURE_LIST";
    VisualizationType["FEATURE_LIST_FLASHBLADE"] = "FEATURE_LIST_FLASHBLADE";
    VisualizationType["FEATURE_LIST_PURE1"] = "FEATURE_LIST_PURE1";
    VisualizationType["FEATURE_SUMMARY"] = "FEATURE_SUMMARY";
    VisualizationType["FEATURE_SUMMARY_FLASHBLADE"] = "FEATURE_SUMMARY_FLASHBLADE";
    VisualizationType["FEATURE_SUMMARY_PURE1"] = "FEATURE_SUMMARY_PURE1";
    VisualizationType["ARRAY_GENEALOGY"] = "ARRAY_GENEALOGY";
    VisualizationType["ASSUMPTIONS"] = "ASSUMPTIONS";
    VisualizationType["APP_BANNER"] = "APP_BANNER";
    VisualizationType["HONEYCOMB"] = "HONEYCOMB";
})(VisualizationType || (exports.VisualizationType = VisualizationType = {}));
//# sourceMappingURL=VisualizationType.js.map